const adjustSticky = async function () {
    let section = document.querySelector(".sticky-section");
    function adjustSticky() {
        if (window.innerHeight < section.offsetHeight) {
            section.style.position = "relative";
        } else {
            section.style.position = "";
        }
    }
    if(section) {
        adjustSticky();
        window.addEventListener("resize", adjustSticky);
    }
}

export const init = adjustSticky;